module.exports = __webpack_public_path__ + "img/6.007883c9.png";